import Loader from 'carbon-react/lib/components/loader';

import Translate from '../Translate/Translate';

interface SpinnerProps {
  size: 'small' | 'medium' | 'large';
  text?: string;
}

const Spinner = ({ size = 'large', text }: SpinnerProps) => {
  return (
    <div className="custom-spinner">
      {text ? <span>{text}</span> : <Translate scope="Loading" />}
      <Loader isActive size={size} />
    </div>
  );
};

export default Spinner;
